import { Collapse } from "antd";
import { useState } from "react";
import "../styles/QandA.css";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useSelector } from "react-redux";
import { t } from "../../translations";
import { createLogger } from "../../utils/logger";

const logger = createLogger("QandA");
const QandA = () => {
  const { Panel } = Collapse;
  const lang = useSelector((state) => state.lang);

  const PanelActive = {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false
  };
  const [_, setActivePanel] = useState(PanelActive);

  return (
    <div style={{ width: "80%", marginTop: "100px" }}>
      <div className="collapseContainer">
        <h2 className="FAQ-h2">{t("q_and_a.faq_title", lang)}</h2>

        <Collapse
          className="collapse"
          expandIconPosition={"right"}
          Collapse={(Collapse) => logger.log(Collapse)}
          onChange={(collapse) => {
            setActivePanel(collapse);
            logger.log(collapse);
          }}
          expandIcon={({ isActive }) => {
            if (isActive) {
              return (
                <IoIosArrowUp type="caret-right" style={{ fontSize: "20px" }} />
              );
            }
            return (
              <IoIosArrowDown
                type="caret-right"
                color="black"
                style={{ fontSize: "20px" }}
              />
            );
          }}
        >
          <Panel
            className="panel"
            header={<span>{t("q_and_a.what_is_pani_q", lang)}</span>}
            key="1"
            id="1"
          >
            {t("q_and_a.what_is_pani_a_prefix", lang)}{" "}
            <a href="mailto:onboarding@panichefs.com">
              onboarding@panichefs.com
            </a>
            {t("q_and_a.what_is_pani_a_suffix", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_cooking_works_q", lang)}</span>}
            key="2"
          >
            {t("q_and_a.how_cooking_works_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_delivery_works_q", lang)}</span>}
            key="3"
          >
            {t("q_and_a.how_delivery_works_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_many_days_cook_q", lang)}</span>}
            key="4"
          >
            {t("q_and_a.how_many_days_cook_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_delivery_works_2_q", lang)}</span>}
            key="5"
          >
            {t("q_and_a.how_delivery_works_2_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.who_are_customers_q", lang)}</span>}
            key="6"
          >
            {t("q_and_a.who_are_customers_a", lang)}
          </Panel>
        </Collapse>
        <Collapse
          className="collapse"
          expandIconPosition={"right"}
          Collapse={(Collapse) => logger.log(Collapse)}
          onChange={(collapse) => {
            setActivePanel(collapse);
            logger.log(collapse);
          }}
          expandIcon={({ isActive }) => {
            if (isActive) {
              return (
                <IoIosArrowUp type="caret-right" style={{ fontSize: "20px" }} />
              );
            }
            return (
              <IoIosArrowDown
                type="caret-right"
                color="black"
                style={{ fontSize: "20px" }}
              />
            );
          }}
        >
          <Panel
            className="panel"
            header={<span>{t("q_and_a.who_can_cook_q", lang)}</span>}
            key="7"
          >
            {t("q_and_a.who_can_cook_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_many_days_cook_q", lang)}</span>}
            key="8"
          >
            {t("q_and_a.how_many_days_cook_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.can_take_break_q", lang)}</span>}
            key="9"
          >
            {t("q_and_a.can_take_break_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_am_i_paid_q", lang)}</span>}
            key="10"
          >
            {t("q_and_a.how_am_i_paid_a", lang)}
          </Panel>
          <Panel
            className="panel"
            header={<span>{t("q_and_a.how_packaging_works_q", lang)}</span>}
            key="11"
          >
            {t("q_and_a.how_packaging_works_a", lang)}
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default QandA;
